/*
 * @Author: Roman
 * @Date: 2022-12-14 11:15:46
 * @LastEditors: romanyuen@qpp.com yuan719...
 * @LastEditTime: 2022-12-28 16:57:06
 * @FilePath: \qpmn-site\src\app\modules\product\catalog-product\rest\catalog-product-rest.service.ts
 * @Description: 
 */
import { IDataAccessor, AbstractAccessorService } from "@core/data-access";
import { IResponse } from "@core/data-access/model";
import {IPaging} from "@core/data-access/model";
import {ICatalogProductRestService} from "./catalog-product-rest";
import type {CatalogProduct} from "../model/dto/CatalogProduct";

type resultlimitType = {page: number, limit: number, filter: string};
 export class CatalogProductRestService extends AbstractAccessorService<CatalogProduct> implements ICatalogProductRestService{
    public readonly $name: string = "catalogProductRestService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<CatalogProduct>) {
        super();
    }

    public getCatalogResult(parameter: resultlimitType): angular.IPromise<IResponse<IPaging<CatalogProduct>>> {
        return this.$accessor<IPaging<CatalogProduct>, resultlimitType, "getCatalogResult">(this.$name, "getCatalogResult", {
            parameter: parameter
        });
    }
 }